import gql from 'graphql-tag';

const GET_VENDOR_CONVERSATION_PARENT_LIST = gql`
  query getVendorConversationsList($input: GetVendorConversationListInput!) {
    getVendorConversationsList(input: $input) {
      conversations {
        conversationId
        subject
        time
        type
        opened
        workItem {
          workId
          module
          subject
          displayId
        }
        latestReply {
          type
          conversationId
          time
          user {
            userId
            email
          }
        }
      }
      listInfo {
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_VENDOR_CONVERSATION_LIST = gql`
  query getVendorConversationsList($input: GetVendorConversationListInput!) {
    getVendorConversationsList(input: $input) {
      conversations {
        minifiedContent
        conversationId
        parentConversationId
        subject
        content
        time
        type
        opened
        user {
          name
          email
          userId
          firstName
          lastName
          accountType
        }
        toUsers {
          user {
            userId
            firstName
            lastName
            name
            email
          }
        }
        ccUsers {
          user {
            userId
            firstName
            lastName
            name
            email
          }
        }
        bccUsers {
          user {
            userId
            firstName
            lastName
            name
            email
          }
        }
        attachments {
          fileName
          originalFileName
          fileSize
        }
        workItem {
          workId
          module
          subject
          displayId
        }
        latestReply {
          type
          conversationId
          user {
            userId
            firstName
            lastName
            name
            email
          }
        }
        outgoingMailStatus
        outgoingMailFailureReason
      }
      listInfo {
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const CREATE_VENDOR_CONVERSATION = gql`
  mutation($input: ConversationInput!) {
    createVendorConversation(input: $input) {
      minifiedContent
      conversationId
      parentConversationId
      subject
      content
      time
      type
      user {
        userId
        name
        email
        firstName
        lastName
        accountType
      }
      opened
      client {
        name
        accountId
      }
      toUsers {
        user {
          userId
          firstName
          lastName
          name
          email
        }
      }
      ccUsers {
        user {
          userId
          firstName
          lastName
          name
          email
        }
      }
      bccUsers {
        user {
          userId
          firstName
          lastName
          name
          email
        }
      }
      attachments {
        fileName
        originalFileName
        fileSize
      }
      workItem {
        workId
        module
        subject
        displayId
      }
      latestReply {
        type
        conversationId
        user {
          userId
          firstName
          lastName
          name
          email
        }
      }
      outgoingMailStatus
      outgoingMailFailureReason
    }
  }
`;

const GET_VENDOR_CONVERSATION_THREADED_CONTENT = gql`
  query getVendorConversationThreadedContent(
    $input: GetVendorConversationThreadedContentInput!
  ) {
    getVendorConversationThreadedContent(input: $input)
  }
`;

const GET_VENDOR_CONVERSATION_REPLY_RECIEPIENTS = gql`
  query getVendorConversationReplyRecipients(
    $input: GetVendorConversationThreadedContentInput!
  ) {
    getVendorConversationReplyRecipients(input: $input) {
      to {
        userId
        name
        email
      }
      cc {
        userId
        name
        email
      }
      selectedMailbox {
        boxId
        outgoingAddress
        outgoingDomainVerified
        emailSignature
      }
      mailboxes {
        boxId
        outgoingAddress
        outgoingDomainVerified
        emailSignature
      }
    }
  }
`;

const UPDATE_VENDORCONVERSATION_READ_STATUS = gql`
  mutation updateVendorConversationReadStatus(
    $input: UpdateVendorConversationReadStatusInput!
  ) {
    updateVendorConversationReadStatus(input: $input)
  }
`;

const RESEND_VENDOR_CONVERSATION = gql`
  mutation($input: ResendVendorConversationInput!) {
    resendVendorConversation(input: $input) {
      conversationId
      outgoingMailStatus
      outgoingMailFailureReason
    }
  }
`;

const GET_EXPANDED_VENDOR_CONVERSATION_CONTENT = gql`
  query getExpandedVendorConversationContent(
    $input: GetExpandedVendorConversationContentInput!
  ) {
    getExpandedVendorConversationContent(input: $input) {
      conversationId
      time
      subject
      user {
        userId
        firstName
        lastName
        email
        name
      }
      toUsers {
        user {
          userId
          firstName
          lastName
          name
          email
        }
      }
      ccUsers {
        user {
          userId
          firstName
          lastName
          name
          email
        }
        mailDeliveryStatus
        mailFailureReason
      }
      bccUsers {
        user {
          userId
          firstName
          lastName
          name
          email
        }
        mailDeliveryStatus
        mailFailureReason
      }
      attachments {
        fileName
        originalFileName
        fileSize
      }
      content
    }
  }
`;

const SEARCH_VENDOR_CONVERSATION_RECIPIENT = gql`
  query searchVendorConversationRecipient(
    $input: SearchVendorConversationRecipientInput!
  ) {
    searchVendorConversationRecipient(input: $input) {
      userList {
        userId
        # idpSubjectIdentifier
        # firstName
        # lastName
        name
        # avatarFileName
        email
      }
      listInfo {
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

export {
  GET_VENDOR_CONVERSATION_LIST,
  GET_VENDOR_CONVERSATION_PARENT_LIST,
  CREATE_VENDOR_CONVERSATION,
  GET_VENDOR_CONVERSATION_THREADED_CONTENT,
  GET_VENDOR_CONVERSATION_REPLY_RECIEPIENTS,
  UPDATE_VENDORCONVERSATION_READ_STATUS,
  RESEND_VENDOR_CONVERSATION,
  GET_EXPANDED_VENDOR_CONVERSATION_CONTENT,
  SEARCH_VENDOR_CONVERSATION_RECIPIENT
};
